import { type RouteObject } from "react-router-dom";
import { PrivateRoute } from "./RouteGuards";
import React from "react";

const DashboardScreen = React.lazy(() => import("@/Dashboard/Infraestructure/pages/Dashbaord"));
const AgentSearchResultsScreen = React.lazy(() => import("@/Dashboard/Infraestructure/pages/AgentSearchResults.page"));
const AgentInfoPage = React.lazy(() => import("@/Dashboard/Infraestructure/pages/AgentInfo.page"));
// Comentado: Páginas de autor
// const MyAgentsPage = React.lazy(() => import("@/Dashboard/Infraestructure/pages/MyAgents.page"));
// const TransactionsPage = React.lazy(() => import("@/Dashboard/Infraestructure/pages/TransactionsPage"));
// const EditAgentPage = React.lazy(() => import("@/AuthorsModule/infraestructure/pages/EditAgent.page"));
const MyPurchasedAgentsPage = React.lazy(() => import("@/Dashboard/Infraestructure/pages/MyPurchasedAgents.page"));
const AgentDashboardPage = React.lazy(() => import("@/Dashboard/Infraestructure/pages/AgentDashboard.page"));
const InvoicesPage = React.lazy(() => import("@/Dashboard/Infraestructure/pages/InvoicesPage"));
const BillingDataFormPage = React.lazy(() => import("@/Dashboard/Infraestructure/pages/BillingDataFormPage"));

//examples


export const privateRoutes: RouteObject[] = [
  {
    path: "/discoverAgents",
    element: (
      <PrivateRoute>
        <DashboardScreen />
      </PrivateRoute>
    ),
  },
  {
    path: "/agentSearchResults",
    element: (
      <PrivateRoute>
        <AgentSearchResultsScreen />
      </PrivateRoute>
    ),
  },
  {
    path: "/agentInfo/:id",
    element: (
      <PrivateRoute>
        <AgentInfoPage />
      </PrivateRoute>
    ),
  },
  /* Comentado: Rutas de autor
  {
    path: "/myAgents",
    element: (
      <PrivateRoute>
        <MyAgentsPage />
      </PrivateRoute>
    ),
  },
  {
    path: "/transactions",
    element: (
      <PrivateRoute>
        <TransactionsPage />
      </PrivateRoute>
    ),
  },
  {
    path: "/editAgent/:id",
    element: (
      <PrivateRoute>
        <EditAgentPage />
      </PrivateRoute>
    ),
  },
  */
  {
    path: "/myPurchasedAgents",
    element: (
      <PrivateRoute>
        <MyPurchasedAgentsPage />
      </PrivateRoute>
    ),
  },
  {
    path: "/agentDashboard/:id",
    element: (
      <PrivateRoute>
        <AgentDashboardPage />
      </PrivateRoute>
    ),
  },
  {
    path: "/invoices",
    element: (
      <PrivateRoute>
        <InvoicesPage />
      </PrivateRoute>
    ),
  },
  {
    path: "/billing-data",
    element: (
      <PrivateRoute>
        <BillingDataFormPage />
      </PrivateRoute>
    ),
  },
];
